import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import _ from 'lodash';

const Context = React.createContext();

export const FaqCategoriesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseFaqs/${props.faqCategoryId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseFaqs`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseFaqs/${props.faqCategoryId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        let url = 'FranchiseFaqs/Franchise';

        if (!_.isEmpty(props && !_.isEmpty(props.franchiseId))) { url = `${url}/${props.franchiseId}`; }

        await execute({ scope: 'list', url: url, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseFaqs/${props.faqCategoryId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFaqCategoriesStore = () => React.useContext(Context);
